import React, { Component } from 'react';
import { numberWithCommas } from '../utility/tool';
import IconButton from 'material-ui/IconButton';

const tooltipStyle = {
  contentBig: {
  	width: '380px',
  	whiteSpace: 'initial',
  	textAlign:'justify',
  	fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"'
  },
  contentSmall: {
  	textAlign:'justify',
  	fontFamily: '"Noto Sans TC","WenQuanYi Zen Hei","Heiti TC","Helvetica","Microsoft YaHei","Microsoft JhengHei","Arial","sans-serif"'
  },
}

export default class ProfileSection2 extends Component{
	render () {
		 // handle data from API KOLprofile
			const leaderInfo = this.props.leaderInfo

			const leaderValue = Math.round(leaderInfo.value.leader_value)
			const fans_scale = Math.round(leaderInfo.value.fans_scale)
			const growth = Math.round(leaderInfo.value.growth)
			const total_reaction = Math.round(leaderInfo.value.total_reaction)
			const relevance = Math.round(leaderInfo.value.relevance)
			const reaction = Math.round(leaderInfo.value.reaction)
			const views = Math.round(leaderInfo.value.views)

			const performance = Math.round(leaderInfo.value.performance)

	  	return (
	  		<div className="profile_section2">
	  			<div className="boxLeft">
	  				<div className="leadervalueWrapper">
	  					<div className="k_sprite1 sprite-icon-leadervalue iconHead"></div>
	  					<div className="title">
	  						<p>領袖價值</p>
	  						<p>Leader Value</p>
	  						<IconButton
	  						  className="infoIcon"
	  						  iconClassName="material-icons" 
	  						  iconStyle={{color:"#7b6448"}}
	  						  tooltip={
	  						  	<div style={tooltipStyle.contentSmall}>
	  						  		領袖價值綜合右方6項指標，分數落在60~100之間<br/>
	  						  		<br/>
	  						  		80 ~ 83 為一般 (超過50%的KOL)<br/>
	  						  		83 ~ 86 為中上 (超過68%的KOL)<br/>
	  						  		87 ~ 90 為優秀 (超過95%的KOL)<br/>
	  						  		91 以上為極優秀 (超過99%的KOL)
	  						  	</div>
	  						  }
	  						  tooltipPosition="top-right"
	  						  tooltipStyles={{fontSize:'14px',fontWeight:'300',padding:'5px 10px'}}
	  						>
	  						  info
	  						</IconButton>
	  					</div>
	  				</div>
	  				<div className="value"><span>{numberWithCommas(leaderValue)}</span>分</div>
	  			</div>
	  			<div className="boxRight">
	  				<div className="keyValueWrapper">
	  					<div className="infoBoxRight">
	  						<div className="infoBoxRow marginBottom">
	  							<div className="infoBoxWrapper">
	  								<div className="infoBox">
	  									<p className="title">粉絲規模</p>
	  									<IconButton
	  									  className="infoIcon"
	  									  iconClassName="material-icons" 
	  									  iconStyle={{color:"#7b6448"}}
	  									  tooltip={
	  									  	<div style={tooltipStyle.contentBig}>
	  									  		粉絲規模：各社群平台粉絲人數(訂閱人數)總和<br/>
	  									  		<br/>
	  									  		分數解讀：在篩選條件下，此KOL的粉絲人數(訂閱人數)總和，與篩選結果名單其他KOL比較之下的得分。分數落在60~100間，達到87以上即代表優秀(超過95%的KOL)。
	  									  	</div>
	  									  }
	  									  tooltipPosition="top-right"
	  									  tooltipStyles={{fontSize:'14px',fontWeight:'300',padding:'5px 10px'}}
	  									>
	  									  info
	  									</IconButton>
	  									<span className="value">{numberWithCommas(fans_scale)}</span>
	  								</div>
	  							</div>
	  							<div className="infoBoxWrapper">
	  								<div className="infoBox">
	  									<p className="title">粉絲成長</p>
	  									<IconButton
	  									  className="infoIcon"
	  									  iconClassName="material-icons" 
	  									  iconStyle={{color:"#7b6448"}}
	  									  tooltip={
	  									  	<div style={tooltipStyle.contentBig}>
	  									  		粉絲成長：各社群平台的粉絲新增(或減少)人數總和<br/>
	  									  		<br/>
	  									  		分數解讀：在篩選條件下，此KOL粉絲新增(或減少)人數總和，與篩選結果名單其他KOL比較之下的得分。分數落在60~100間，達到87以上即代表優秀(超過95%的KOL)。
	  									  	</div>
	  									  }
	  									  tooltipPosition="top-right"
	  									  tooltipStyles={{fontSize:'14px',fontWeight:'300',padding:'5px 10px'}}
	  									>
	  									  info
	  									</IconButton>
	  									<span className="value">{numberWithCommas(growth)}</span>
	  								</div>
	  							</div>
	  							<div className="infoBoxWrapper">
	  								<div className="infoBox">
	  									<p className="title">粉絲經營</p>
	  									<IconButton
	  									  className="infoIcon"
	  									  iconClassName="material-icons"
	  									  iconStyle={{color:"#7b6448"}}
	  									  tooltip={
	  									  	<div style={tooltipStyle.contentBig}>
	  									  		粉絲經營：平均每位粉絲對各社群平台貼文的互動數<br/>
	  									  		<br/>
	  									  		分數解讀：在篩選條件下，此KOL平均每位粉絲對貼文的互動數，與篩選結果名單其他KOL比較之下的得分。分數落在60~100間，達到87以上即代表優秀(超過95%的KOL)。
	  									  	</div>
	  									  }
	  									  tooltipPosition="top-left"
	  									  tooltipStyles={{fontSize:'14px',fontWeight:'300',padding:'5px 10px'}}
	  									>
	  									  info
	  									</IconButton>
	  									<span className="value">{numberWithCommas(total_reaction)}</span>
	  								</div>
	  							</div>
	  						</div>
	  						<div className="infoBoxRow">
	  							<div className="infoBoxWrapper">
	  								<div className="infoBox">
	  									<p className="title">貼文相關</p>
	  									<IconButton
	  									  className="infoIcon"
	  									  iconClassName="material-icons"
	  									  iconStyle={{color:"#7b6448"}}
	  									  tooltip={
	  									  	<div style={tooltipStyle.contentBig}>
	  									  		貼文相關：各社群平台符合關鍵字的貼文則數(若無設定關鍵字則為貼文總數)<br/>
	  									  		<br/>
	  									  		分數解讀：在篩選條件下，此KOL符合關鍵字的貼文則數，與篩選結果名單其他KOL比較之下的得分。分數落在60~100間，達到87以上即代表優秀(超過95%的KOL)。
	  									  	</div>
	  									  }
	  									  tooltipPosition="top-right"
	  									  tooltipStyles={{fontSize:'14px',fontWeight:'300',padding:'5px 10px'}}
	  									>
	  									  info
	  									</IconButton>
	  									<span className="value">{numberWithCommas(relevance)}</span>
	  								</div>
	  							</div>
	  							<div className="infoBoxWrapper">
	  								<div className="infoBox">
	  									<p className="title">貼文互動</p>
	  									<IconButton
	  									  className="infoIcon"
	  									  iconClassName="material-icons"
	  									  iconStyle={{color:"#7b6448"}}
	  									  tooltip={
	  									  	<div style={tooltipStyle.contentBig}>
	  									  		貼文互動：各社群平台符合關鍵字的貼文(若無設定關鍵字則為所有貼文)，平均每篇貼文可獲得的互動數<br/>
	  									  		<br/>
	  									  		分數解讀：在篩選條件下，此KOL符合關鍵字的貼文平均單則可獲得的互動數，與篩選結果名單其他KOL比較之下的得分。分數落在60~100間，達到87以上即代表優秀(超過95%的KOL)。
	  									  	</div>
	  									  }
	  									  tooltipPosition="top-right"
	  									  tooltipStyles={{fontSize:'14px',fontWeight:'300',padding:'5px 10px'}}
	  									>
	  									  info
	  									</IconButton>
	  									<span className="value">{numberWithCommas(reaction)}</span>
	  								</div>
	  							</div>
	  							<div className="infoBoxWrapper">
	  								<div className="infoBox">
	  									<p className="title">影片觀看</p>
	  									<IconButton
	  									  className="infoIcon"
	  									  iconClassName="material-icons"
	  									  iconStyle={{color:"#7b6448"}}
	  									  tooltip={
	  									  	<div style={tooltipStyle.contentBig}>
	  									  		影片觀看：符合關鍵字的影片(若無設定關鍵字則為所有影片)，平均每則影片可獲得的觀看數<br/>
	  									  		<br/>
	  									  		分數解讀：在篩選條件下，此KOL符合關鍵字的影片平均單則可獲得的觀看數，與篩選結果名單其他KOL比較之下的得分。分數落在60~100間，達到87以上即代表優秀(超過95%的KOL)。
	  									  	</div>
	  									  }
	  									  tooltipPosition="top-left"
	  									  tooltipStyles={{fontSize:'14px',fontWeight:'300',padding:'5px 10px'}}
	  									>
	  									  info
	  									</IconButton>
	  									<span className="value">{numberWithCommas(views)}</span>
	  								</div>
	  							</div>
	  						</div>
	  					</div>
	  				</div>
	  			</div>
	  		</div>
	    )
  	}
}



// WEBPACK FOOTER //
// ./src/components/profileSection2.js